import { NonUndefined } from 'react-hook-form'
import { DialogContentProps } from 'components/DialogContent/DialogContent'

export const DIALOG_CONTENT_SIZE: Record<NonUndefined<DialogContentProps['size']>, string> = {
  medium: '500px',
  large: '900px',
}
